import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import api from '../../services/api';

export default function CorretoresReaquecidos() {
  const { data, isLoading } = useQuery({
    queryKey: ['parceiros-reaquecidos'],
    queryFn: () => api.get('/parceiros/reaquecidos').then(r => r.data),
  });

  const corretores = data?.data || [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Corretores Reaquecidos</h1>
      </div>

      <div className="bg-white rounded-xl shadow overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center text-gray-400">Carregando...</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-xs uppercase tracking-wider">
              <tr>
                <th className="px-6 py-3 text-left">Nome</th>
                <th className="px-6 py-3 text-left">WhatsApp</th>
                <th className="px-6 py-3 text-left">Resumo da Conversa</th>
                <th className="px-6 py-3 text-left">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {corretores.map(c => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-800">{c.contact_name}</td>
                  <td className="px-6 py-4 text-gray-600">{c.phone}</td>
                  <td className="px-6 py-4 text-gray-600 text-xs max-w-md">{c.resumo_conversa || '—'}</td>
                  <td className="px-6 py-4 text-gray-400 text-xs">
                    {c.created_at ? format(new Date(c.created_at), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : '—'}
                  </td>
                </tr>
              ))}
              {!corretores.length && (
                <tr><td colSpan={4} className="px-6 py-8 text-center text-gray-400">Nenhum corretor reaquecido encontrado</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
